module.exports = __webpack_public_path__ + "static/img/7.096d1a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/7.png
// module id = ZhHz
// module chunks = 0